module.exports = __webpack_public_path__ + "img/stor_wrapbg3.e2b2041b.png";